

/**
 * A helper for firing events on the front-end which have been triggered from
 * the back-end. This is a companion to the `CS\Analytics\Actions\AnalyticsData`
 * class.
 */
(function(window) {
  var events = window.analyticsEvents;

  if (events && events.length) {
    window.addEventListener('load', function() {
      for (var i = 0; i < events.length; i++) {
        var e = events[i];

        window.CSAnalytics(e.event, e.data);
      }
    });
  }
})(window);

